export default "<xo-tile title=\"Admin Component\">\n</xo-tile>\n";